import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  List,
  ListItem,
  Checkbox,
  ListItemText,
  Box,
} from '@material-ui/core';
import { isEmpty } from 'lodash-es';
import {QrReader} from 'react-qr-reader';
import { Alert } from '@material-ui/lab';
import scanSound from "./sounds/scan.mp3"
import scanSoundError from "./sounds/scanError.mp3"
import scanSoundDouble from "./sounds/scanDouble.mp3"
import QRCode from 'react-qr-code';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // maxWidth: 360,
    flex: 1, 
    padding: '10px',
    backgroundColor: theme.palette.background.paper,
  },
  disabledItem: {
    textDecoration: 'line-through', 
    color: 'gray',
  },
}));

const CheckProductList = ({ products, onSelectedProductsChange }) => {
    const classes = useStyles();
    const [checked, setChecked] = useState([]);
    const [scannedRFID, setScannedRFID] = useState(null);
    const [scanSuccess, setScanSuccess] = useState(false);
    const [scanError, setScanError] = useState(null);
    const scanSoundSuccess = useRef(new Audio(scanSound));
    const soundError = useRef(new Audio(scanSoundError));
    const soundDouble = useRef(new Audio(scanSoundDouble));
    
    useEffect(() => {
        scanSoundSuccess.current.addEventListener('error', (event) => {
            console.error('Erreur de chargement du son:', event);
        });
        soundError.current.addEventListener('error', (event) => {
            console.error('Erreur de chargement du son:', event);
        });
        soundDouble.current.addEventListener('error', (event) => {
            console.error('Erreur de chargement du son:', event);
        });

        return () => {
            scanSoundSuccess.current.removeEventListener('ended', () => {});
            soundError.current.removeEventListener('ended', () => {});
            soundDouble.current.removeEventListener('ended', () => {});
        };
    }, []);

    const handleError = (err) => {
        console.error(err);
    };
    const playSound = (sound) => {
        sound.current.play();
    };
    const handleResult = (result) => {
        if (result) {
          const scannedRFID = result.text;
          const productWithScannedRFID = products.find((product) => product.RFID === scannedRFID);
      
          if (productWithScannedRFID) {
            handleToggleScan(productWithScannedRFID.id, productWithScannedRFID.block_id, productWithScannedRFID.RFID, productWithScannedRFID.available)();
            setScanSuccess(true);
            setScanError(null);
            playSound(scanSoundSuccess);
        } else {
            setScanSuccess(false);
            setScanError("Objet non trouvé dans la liste.");
            playSound(soundError);
            // Ajouter le son ou le signe visuel d'erreur ici
          }
        }
    };
      
    const handleToggleScan = (productId, blockId, rfid, available) => () => {
        // Si un QR code est scanné, cochez le produit correspondant
        if (blockId || !available) {
            return;
        }
        if (scannedRFID && scannedRFID === rfid) {
            const newChecked = [...checked, productId];
            setChecked(newChecked);
            onSelectedProductsChange(newChecked);
            setScannedRFID(null);
        } 
        const currentIndex = checked.indexOf(productId);
        const newChecked = [...checked];
    
        if (currentIndex === -1) {
            newChecked.push(productId);
        } else {
            newChecked.splice(currentIndex, 1);
        }
    
        setChecked(newChecked);
        onSelectedProductsChange(newChecked);
    };
    const handleToggle = (productId, blockId, available) => () => {
       
        if (blockId || !available) {
            return;
        }
    
        const currentIndex = checked.indexOf(productId);
        const newChecked = [...checked];
    
        if (currentIndex === -1) {
            newChecked.push(productId);
        } else {
            newChecked.splice(currentIndex, 1);
        }
    
        setChecked(newChecked);
        onSelectedProductsChange(newChecked);
        
    };

    return (
        <Box style={{ display: "flex"}}>
            <Box style={{ flex: 1, padding: '10px' }}>
                <QrReader
                    delay={300}
                    onError={handleError}
                    // onScan={handleScan}
                    style={{ width: '100%' }}
                    onResult={handleResult}
                />
                {scanSuccess && (
                    <Alert severity="success" sx={{ marginBottom: 1 }}>
                        Produit trouvé. Scannez l'article suivant
                    </Alert>
                )}
                {scanError && (
                    <Alert severity="error" sx={{ marginBottom: 1 }}>
                        {scanError}
                    </Alert>
                )}
                
            </Box>
            <List className={classes.root}>
                {/* {products.filter((prod) => prod.available).map((product) => { */}
                {products.map((product) => {
                    const { id, quantity, RFID, storage_block_id, available } = product;
                    const labelId = `checkbox-list-label-${id}`;
            
                    return (
                        <ListItem
                            key={id}
                            role={undefined}
                            dense
                            button
                            onClick={ handleToggle(id, storage_block_id, available)}
                            className={storage_block_id || !available ? classes.disabledItem : ""}
                        >
                            <Checkbox
                                edge="start"
                                checked={checked.indexOf(id) !== -1}
                                tabIndex={-1}
                                disableRipple
                                inputProps={{ 'aria-labelledby': labelId }}
                                disabled={storage_block_id || !available} // Désactivez la case pour les éléments déja rangé ou vendu
                            />
                            {/* <Box p={3}>
                                <QRCode value={RFID} size={80} />
                            </Box> */}
                            <ListItemText id={labelId} primary={`RFID: ${RFID} - Quantity: ${quantity}`} />
                        </ListItem>
                    );
                })}
            </List>
        </Box>
    );
};

export default CheckProductList;
